<template>
    <div class="main" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>分销</el-breadcrumb-item>
            <el-breadcrumb-item>分销设置</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box">
                <Card :bordered="false" dis-hover class="ivu-mt fromBox">
                    <div class="">
                        <div class="" :title="title" hidden-breadcrumb>
                            <div slot="content">
                                <Form class="ivu-col ivu-col-span-13 form-submit input-build" :model="formItem" :label-width="200">
                                    <Tabs v-model="currentTab">
                                        <TabPane :label="item.label" :name="item.value.toString()" v-for="(item,index) in headerList" :key="index">
                                            <div v-if="item.value == 'basic' && formItem.basic">
                                                <FormItem label="分销启用" prop="is_open">
                                                    <RadioGroup element-id="is_open"  v-model="formItem.basic.values.is_open" prop="is_open">
                                                        <Radio :label="1" class="radio">开启</Radio>
                                                        <Radio :label="0" class="radio">关闭</Radio>
                                                    </RadioGroup>
                                                    <div class="info-wrapper">是否开启分销功能</div>
                                                </FormItem>
                                                <FormItem label="分销层级" prop="level">
                                                    <RadioGroup element-id="level"  v-model="formItem.basic.values.level">
                                                        <Radio :label="1" class="radio">一级</Radio>
                                                        <Radio :label="2" class="radio">二级</Radio>
                                                        <Radio :label="3" class="radio">三级</Radio>
                                                    </RadioGroup>
                                                    <div class="info-wrapper">默认佣金比例请到分销商等级进行设置</div>
                                                </FormItem>
                                                <FormItem label="分销商内购" prop="self_buy">
                                                    <RadioGroup element-id="self_buy"  v-model="formItem.basic.values.self_buy">
                                                        <Radio :label="1" class="radio">开启</Radio>
                                                        <Radio :label="0" class="radio">关闭</Radio>
                                                    </RadioGroup>
                                                    <div class="info-wrapper">注：分销商自己购买商品，获得一级佣金，上级获得二级佣金</div>
                                                </FormItem>
                                            </div>
                                            <div v-if="item.value == 'condition' && formItem.condition">
                                                <FormItem label="成为分销商条件" prop="become">
                                                    <RadioGroup element-id="become"  v-model="formItem.condition.values.become" prop="become">
                                                        <Radio :label="0" class="radio">无条件</Radio>
                                                        <Radio :label="1" class="radio">需后台审核</Radio>
                                                        <Radio :label="2" class="radio">达到特定条件</Radio>
                                                    </RadioGroup>
                                                    <div class="info-wrapper">特定条件请到分销商默认等级设置</div>
                                                </FormItem>
                                            </div>
                                            <div v-if="item.value == 'settlement' && formItem.settlement">
                                                <FormItem label="提现方式" prop="pay_type">
                                                    <Checkbox-group v-model="formItem.settlement.values.pay_type">
                                                        <Checkbox :label="10">
                                                            <span>提现到积分</span>
                                                        </Checkbox>
                                                        <Checkbox :label="20">
                                                            <span>提现到支付宝</span>
                                                        </Checkbox>
                                                        <Checkbox :label="30">
                                                            <span>提现到银行卡</span>
                                                        </Checkbox>
                                                    </Checkbox-group>
                                                    <div class="info-wrapper">
                                                        支付宝支付和银行卡支付需要线下手动打款
                                                    </div>
                                                </FormItem>
                                                <FormItem label="最低提现额度" prop="min_money">
                                                    <div class="acea-row row-middle">
                                                        <InputNumber  placeholder="" :min="0" :precision="0" v-model="formItem.settlement.values.min_money" class="perW20"/><span class="ml">元</span>
                                                    </div>
                                                    <div class="info-wrapper">
<!--                                                        如使用微信企业付款，则打款额度必须大于0.30元-->
                                                    </div>
                                                </FormItem>
                                                <FormItem label="佣金结算周期" prop="settle_days">
                                                    <div class="acea-row row-middle">
                                                        <InputNumber  placeholder="" :min="0" :precision="0" v-model="formItem.settlement.values.settle_days" class="perW20"/><span class="ml">天</span>
                                                    </div>
                                                    <div class="info-wrapper">
                                                        佣金结算规则：用户下单付款 -> 订单完成确认收货 -> 超出售后期限 -> 结算佣金
                                                    </div>
                                                </FormItem>
                                            </div>
                                        </TabPane>
                                    </Tabs>
                                </Form>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <div class="fixed-card">
                            <Card :bordered="false" dis-hover class="ivu-mt fromBox">
                                <Button type="primary" @click="onSubmit">提交</Button>
                            </Card>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
    import second from "../second.vue";
    export default {
        name: "index",
        components: { second },
        data () {
            return {
                isLoad: false,
                currentTab: '',
                headerList: [
                    {
                        label: '基础设置',
                        value: 'basic'
                    },
                    {
                        label: '分销商条件',
                        value: 'condition'
                    },
                    {
                        label: '结算方式',
                        value: 'settlement',
                    }
                ],
                title: '',
                key: 'payment',
                formItem: {
                },
                ruleValidate: {
                },
                loading: false
            }
        },
        // 初始化数据
        created () {
            // 获取当前详情记录
            this.getDetail()
        },
        methods: {
            getDetail: function () {
                let that = this;
                that.loading = true;
                this.axios.post('/store/app.dealer.setting/detail',{
                })
                .then(async (res) => {
                    if (res.code == 1 && res.data.values) {
                        that.formItem = res.data.values
                    }
                })
                .catch((res) => {
                    that.loading = false;
                    that.$Message.error(res.msg);
                });
            },
            onSubmit: function () {
                var that = this

                this.axios.post('/store/app.dealer.setting/update',{
                    form: this.formItem,
                })
                .then(async (res) => {
                    if (res.code == 1) {
                        this.$Message.success(res.msg);
                    }
                })
                .catch((res) => {
                    that.loading = false;
                    that.$Message.error(res.msg);
                });
            }
        }
    }
</script>

<style scoped>

</style>
